import Auth from "../Auth";

export default class Folder {
  constructor(folder) {
    this.ref = folder;
  }

  get id() {
    return this.ref.id;
  }

  get title() {
    return this.ref.title;
  }

  get parentId() {
    return this.ref.parent_folder_id;
  }

  get projects() {
    return this.ref.projects;
  }

  get nonDeletedProjects() {
    return this.ref.projects.filter((project) => !project.deleted);
  }

  get folders() {
    return this.ref.folders;
  }

  get nonDeletedFolders() {
    return this.ref.folders.filter((folder) => !folder.deleted);
  }

  get deleted() {
    return this.ref.deleted;
  }

  get userId() {
    return this.ref.user_id;
  }

  get lastActive() {
    return this.ref.last_active;
  }

  get entries() {
    const projects = this.projects.map((project) => ({
      type: "project",
      deleted: project.deleted,
      project,
    }));

    const folders = this.folders.map((folder) => ({
      type: "folder",
      deleted: folder.deleted,
      folder,
    }));

    return [...projects, ...folders].sort((a, b) => a.lastActive - b.lastActive);
  }

  get nonDeletedEntries() {
    return this.entries.filter((entry) => !entry.deleted);
  }

  static async get(folderId) {
    const folder = await Auth.fetchWithIdToken(`/api/folders/${folderId ?? "root"}`).then((data) => data.folder);
    return new Folder(folder);
  }

  static async getAll(updatedAt) {
    return Auth.fetchWithIdToken(`/api/folders/all`, { updatedAt });
  }

  static async create(parentId, folderId, isSeries = false) {
    const folder = await Auth.fetchWithIdToken("/api/folders", {
      parentId,
      folderId,
      isSeries,
      title: isSeries ? "New Series" : undefined,
    }).then((data) => data.folder);
    return new Folder(folder);
  }

  static async delete(folderId) {
    await Auth.fetchWithIdToken(`/api/folders/${folderId}`, { method: "DELETE" });
  }

  static async restore(folderId) {
    await Auth.fetchWithIdToken(`/api/folders/${folderId}/restore`);
  }

  static async move(folderId, parentId) {
    await Auth.fetchWithIdToken(`/api/folders/${folderId}/move`, { parentId });
  }

  static async moveProject(projectId, folderId) {
    await Auth.fetchWithIdToken(`/api/folders/${folderId}/moveProject`, { projectId });
  }

  static async archiveDelete(folderId) {
    await Auth.fetchWithIdToken(`/api/folders/${folderId}/archiveDelete`);
  }

  static async getParents(folderId) {
    const parents = await Auth.fetchWithIdToken(`/api/folders/${folderId ?? "root"}/parents`);
    return parents.parents;
  }

  static async rename(folderId, title) {
    await Auth.fetchWithIdToken(`/api/folders/${folderId}/rename`, { title });
  }
}
